import Vue from "vue";
import VeeValidate from "vee-validate";
import he from "vee-validate/dist/locale/he";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import VueRouter from "vue-router";
import "./scaffoldings";
import Notification from "dev/helpers/Notification";
import "dev/helpers/RoleManager";
import AuthCheck from "dev/packages/AuthCheck";
import "dev/directives/FromHereToEnd";
import {setBaseUrl} from "dev/packages/MyAxios";
import CurrentOrg from "dev/store/modules/CurrentOrg.module";
import * as FilePond from "filepond";


Vue.use(VeeValidate, {
	locale: "he",
	dictionary: {
		he: {
			messages: he.messages
		}
	}
});

FilePond.setOptions({
	server: {
		url: "/api",
		process: {
			url: "/media",
			method: "POST",
			withCredentials: false,
			headers: {
				"X-CSRF-TOKEN": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content"),
			},
		},
	},
});

Vue.use(Notification);
Vue.use(AuthCheck);
store.watch((state) => state.ConfigModule.request.baseUrl, (path) => {
	setBaseUrl(path);
});
Vue.use(VueRouter);
Vue.config.productionTip = false;
store.dispatch(CurrentOrg.types.GET).then(() => {
	new Vue({
		vuetify,
		router,
		store,
		render: h => h(App)
	}).$mount("#app");
});

